// Studio auth — cookie-based sessions (Phase 2A security fix).
// The password is sent ONCE to /api/studio/auth and never stored in the
// browser. Auth rides an httpOnly SameSite cookie; localStorage only keeps
// a UI flag so gates know whether to show the login form.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FLAG = "slowcafe_studio_authed";

function store() {
    try { return window.localStorage; } catch { return null; }
}

export async function loginStudio(pwd) {
    await axios.post(`${API}/studio/auth`, { password: pwd });
    try { store()?.setItem(FLAG, "1"); } catch { /* noop */ }
}

// Legacy shims — password is no longer persisted anywhere.
export function getStudioPassword() { return ""; }

export function setStudioPassword(pwd) {
    try {
        if (pwd) store()?.setItem(FLAG, "1");
        else store()?.removeItem(FLAG);
    } catch { /* noop */ }
}

export function clearStudioPassword() {
    try { store()?.removeItem(FLAG); } catch { /* noop */ }
    axios.post(`${API}/studio/logout`).catch(() => {});
}

// Cookie auth is same-origin: no header needed.
export function studioHeaders() { return {}; }

export function isStudioAuthed() {
    try { return store()?.getItem(FLAG) === "1"; } catch { return false; }
}
